module.exports = __webpack_public_path__ + "static/media/dot.96a9516f.svg";